
import React from "react";
import { getImageSrc } from "../Services/mediaService";

export default function Product(props) {
  const { id, title, price, img, onAddProduct, onProductClick } = props;

  const formatPrice = (value) => {
    return Number(value || 0).toLocaleString("fa-IR");
  };

  const clickHandler = () => {
    onAddProduct(id);
  };

  const handleProductClick = () => {
    if (onProductClick) {
      onProductClick(id);
    }
  };

  return (
    <div
      className="shop-item"
      onClick={handleProductClick}
      style={{ cursor: "pointer" }}
    >
      <span className="shop-item-title">{title}</span>

      <img className="shop-item-image" src={getImageSrc(img)} alt={title} />

      <div className="shop-item-details">
        <span className="shop-item-price">{formatPrice(price)} تومان</span>

        <button
          className="btn btn-primary shop-item-button"
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            clickHandler();
          }}
        >
          افزودن به سبد خرید
        </button>
      </div>
    </div>
  );
}
